import type { FC } from 'react'

import { Translation } from '@/components/i18n/Translation'

const ApiError: FC<{ errorTextId?: string }> = ({
  errorTextId = 'Something went wrong while communicating with the API...',
}) => (
  <div>
    <h2>
      <Translation id="API Error!" />
    </h2>

    <p>
      <Translation id={errorTextId} />
    </p>
  </div>
)

export const createApiError = (errorTextId: string) => ApiError({ errorTextId })

export default ApiError
